import React from "react";
//#region redux
import { AppState } from "store";
import { useDispatch, useSelector } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { loadProfilePicture } from "store/actions/authActions";
//#endregion
//#region types
import { UserProfileContainerProps } from "models/propTypes/navListPropTypes";
//#endregion
//#region components
import UserProfile from "./userProfile";
//#endregion

const UserProfileContainer: React.FC<UserProfileContainerProps> = (props) => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const { profileId, userName, companyName } = useSelector((state: AppState) => ({
    profileId: state.auth.loggedInUser.personId,
    userName: state.auth.loggedInUser.name.split(" ")[0],
    companyName: state.auth.selectedCompany.name ?? "",
  }));

  React.useEffect(() => {
    dispatch(loadProfilePicture(profileId));
  }, [profileId]);

  return <UserProfile profileId={profileId} userName={userName} companyName={companyName} {...props}></UserProfile>;
};

export default UserProfileContainer;
